// extracted by mini-css-extract-plugin
export default {"age_chart":"styles_age_chart__QnzLz","age_chart-mini":"styles_age_chart-mini__MOHy1","donut-mini":"styles_donut-mini__+Kv3S","title-mini":"styles_title-mini__eZw2w"};